import { Address, EMPTY_ADDRESS } from "./address";
import { Client, EMPTY_CLIENT } from "./client";

/** Optional milestone dates (YYYY-MM-DD). `dateReceived` is derived from `timeCreated`, not stored here. */
export type CaseScheduleMilestones = Record<string, string>;

export interface CaseScheduleCustomRow {
  id: string;
  label: string;
  date: string;
}

export interface Case {
  id?: string;
  caseNumber: string;
  transactionType: "purchase" | "refinance" | "cashSale" | "commercial";
  salePrice: string;
  address: Address;
  timeCreated: any;

  buyers: {
    name: string;
    email: string;
  }[];
  sellers: {
    name: string;
    email: string;
  }[];

  sellersAgent: Client;
  buyersAgent: Client;
  lender: Client;

  titleAbstractor: Client;
  surveyor: Client;

  archived: boolean;
  complete: boolean;

  settlementDate?: any;

  /** Editable milestone dates for the case schedule (admin). */
  scheduleMilestones?: CaseScheduleMilestones;
  scheduleCustomRows?: CaseScheduleCustomRow[];

  allEmails: string[];
}

export const EMPTY_CASE: Case = {
  caseNumber: "",
  transactionType: "purchase",
  salePrice: "",
  timeCreated: new Date(),
  address: EMPTY_ADDRESS,
  buyers: [{ name: "", email: "" }],
  sellers: [{ name: "", email: "" }],
  sellersAgent: EMPTY_CLIENT,
  buyersAgent: EMPTY_CLIENT,
  lender: EMPTY_CLIENT,
  titleAbstractor: EMPTY_CLIENT,
  surveyor: EMPTY_CLIENT,
  archived: false,
  complete: false,
  scheduleMilestones: {},
  scheduleCustomRows: [],
  allEmails: [],
};
